module.exports = __webpack_public_path__ + "img/test-1.29a195e5.png";